import { Text } from "@fluentui/react-components";
import React, { useEffect, useRef } from "react";

const ResourceSpaceMapSection = () => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== "https://rx.dooleysmith.uk") return;

      console.log("Message received from iframe:", event.data);
    };

    window.addEventListener("message", (event) => {
      // Handle "Ready" signal from Map
      if (
        event.data &&
        event.data.from === "maps" &&
        event.data.action === "loaded"
      ) {
        console.log(
          "Map signalled ready (action: loaded). Sending initial state...",
          "general",
          event.data
        );
        sendMessage();
        return;
      }
      // Handle updates FROM Map
      if (event.data && event.data.from === "maps" && event.data.data) {
        const incoming = event.data.data;
        // Update UI
        console.log("incoming data", incoming);
      }
    });

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  const sendMessage = () => {
    try {
      const data = {
        from: "workplaces",
        data: {
          date: "13/01/2026",
          timeRange: {
            start: "12:15",
            end: "12:46",
          },
          spaceType: "Room",
          occupancy: 0,
          tags: [],
          equipment: [],
        },
      };

      iframeRef.current?.contentWindow?.postMessage(
        data,
        "https://rx.dooleysmith.uk/maps/?id=36&x=519&y=540"
      );

      console.log(JSON.stringify(data), "sent");
    } catch (err) {
      console.error(err);
      console.log("Error sending message", "error");
    }
  };

  return (
    <>
      <div style={{ width: "100%", height: "100%" }}>
        {/* <iframe
          ref={iframeRef}
          id="MapFunc"
          src="https://rx.dooleysmith.uk/maps/?id=36&x=519&y=540"
          height={"90%"}
          width={"100%"}
          onLoad={sendMessage}
        /> */}

        <Text>Map to be loaded in iFrame</Text>
      </div>
    </>
  );
};

export default ResourceSpaceMapSection;
